module.exports = __webpack_public_path__ + "img/pp_edit_24.2f1056c0.svg";